// components/features/candidatures/CandidaturesList.tsx
import { Candidature } from "../../../types/features/Candidature";
import TableList, { SelectAction } from "../../ui/TableList";
import CandidatureRow from "./CandidatureRow";

interface CandidaturesListProps {
  candidatures: Candidature[];
  onAction: (candidature: Candidature) => void;
  onSelectCandidatures?: (selected: Candidature[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function CandidaturesList({
  candidatures,
  onAction,
  onSelectCandidatures,
  selectable = false,
  selectActions,
}: CandidaturesListProps) {
  const columns = [
    { header: "Candidat", className: "w-2/5" },
    { header: "Téléphone", className: "hidden sm:table-cell w-1/6" },
    { header: "Poste", className: "hidden md:table-cell w-1/4" },
    { header: "Statut", className: "hidden lg:table-cell w-1/6" },
  ];

  return (
    <TableList
      items={candidatures}
      columns={columns}
      getId={(candidature) => candidature.id}
      onAction={onAction}
      onSelectItems={onSelectCandidatures}
      selectable={selectable}
      emptyMessage="Aucune candidature reçue"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(candidature, isSelected, onSelect) => (
        <CandidatureRow
          key={candidature.id}
          candidature={candidature}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}
